// extracted by mini-css-extract-plugin
export default {"zoomModal":"P1-z"};